var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('OrdersCount',{attrs:{"color":_vm.getStautsColor(),"total":_vm.data.incidents,"open":_vm.data.incidents_open}},[_vm._v(_vm._s(_vm.getQta()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }